<template>
    <div v-show="isModalVisible">
        <transition name="slide">
            <div class="modal-mask" @click="close">
                <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop>
                    <div class="modal-content">
                        <div class="modal-header" style="border-bottom: 1px solid #CCC; padding-bottom: 5px; margin:0px 10px 10px 10px;">                            
                            <div class="maheading_2">
                                <h5 class="modal-title">Process Payment</h5>
                            </div>
                            <div class="maheading_3">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="modal-body">
                           <form>
                                 <div class="row">
                                    <div class="col-12">
                                        <div class="row">
                                          <div class="col-6">
                                            <span><label class="form-label">Invoice #:</label></span>
                                            
                                          </div>
                                          <div class="col-2">
                                            <label class="form-label text-center" style="width: 100%;">Due Date:</label>
                                          </div>
                                          <div class="col-4">
                                            <label class="form-label text-center" style="width: 100%;">Amount Due:</label>
                                          </div>
                                        </div>
                                        <div class="row row_data_border" >
                                          <div class="col-6">
                                            <label for="subscription_plan">{{ invoiceNo }}</label>
                                          </div>
                                          <div class="col-2 text-center">
                                            <label for="subscription_plan">{{ dueDate }}</label>
                                          </div>

                                        <div class="col-4">
                                            <label for=""  style="width: 100%; text-align: center;"><span class="dollarsign" >$</span>&nbsp;{{ price }}</label>
                                        </div>
                                        </div>

                                        <div class="row">
                                          <div class="col-9 col-sm-9"></div>
                                          <div class="col-3 col-sm-3" style="text-align: right; padding-right: 45px;">
                                            <button type="button" class="btn btn-sm btn-blue totalBtn text-center">
                                              Total: <span class="total_price">${{ subscriptionTotal }}</span>
                                            </button>
                                          </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <label class="form-label">Billing Information</label>
                                        <div class="row">
                                            <div class="col-12 col-sm-12">      
                                                <input
                                                    type="text"
                                                    id="bname"
                                                    class="col-12 ma-input-field"
                                                    ref="bname"
                                                    name="bname"
                                                    v-model="billingName"
                                                    v-validate="{ rules: { required: true, regex: billingNameRegex() } }"
                                                    placeholder="Billing Name"
                                                    maxlength="250"
                                                    autocomplete="off"
                                                    :disabled="(isAccessPlan) ? false: true">
                                                <div v-if="verrors.firstByRule('bname', 'required')" class="margin-bottom-5 validate-warning-msg">Billing name is required</div>
                                                <div v-if="verrors.firstByRule('bname', 'regex')" class="margin-bottom-5 validate-warning-msg">Billing name should only contain - and _</div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 col-sm-12">
                                                <b-form-select
                                                class="col-12 ma-input-field"
                                                id="country_id" v-model="billingCountry" v-validate="'required'" name="billing_country"
                                                :options="country_options"
                                                v-on:change="getStateLists(billingCountry)"
                                                :disabled="(isAccessPlan) ? false: true">
                                                </b-form-select>
                                                <div v-if="verrors.firstByRule('billing_country', 'required')" class="margin-bottom-5 validate-warning-msg">Country is required</div>
                                            </div>
                                            <div class="col-12 col-sm-12">
                                                <input 
                                                    type="text" 
                                                    class="col-12 col-sm-12 ma-input-field" 
                                                    name="billing_address_1" 
                                                    placeholder="Billing Address 1" 
                                                    v-model="billingAddress" 
                                                    v-validate="'required'"
                                                    maxlength="250"
                                                    :disabled="(isAccessPlan) ? false: true">
                                                <div v-if="verrors.firstByRule('billing_address_1', 'required')" class="margin-bottom-5 validate-warning-msg">Billing Address 1 is required</div>
                                            </div>                 
                                            <div class="col-12 col-sm-12">
                                                <input 
                                                    type="text" 
                                                    class="col-12 col-sm-12 ma-input-field" 
                                                    name="billing_address_2" 
                                                    placeholder="Billing Address 2" 
                                                    v-model="billingAddress2"
                                                    maxlength="250" 
                                                    >
                                                
                                            </div>                                                       
                                            <div class="col-12 col-sm-12">
                                                <input 
                                                type="text" 
                                                name="phone number" 
                                                id="phone_number"
                                                ref="phone_number"
                                                v-validate="{ rules: { regex: phoneRegex(), required: true } }"
                                                v-model="billingPhone"
                                                @keyup="billingPhoneValid"
                                                @blur="billingPhoneValid"
                                                class="col-12 col-sm-12 ma-input-field" 
                                                placeholder="Phone Number"
                                                :disabled="(isAccessPlan) ? false: true">
                                                <div v-show="verrors.has('phone number')" class="validate-warning-msg">{{ verrors.first('phone number') }}</div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-4 col-sm-4">
                                                <input 
                                                    type="text" 
                                                    class="col-12 col-sm-12 ma-input-field" 
                                                    name="billing_city" 
                                                    placeholder="City" 
                                                    v-model="billingCity" 
                                                    v-validate="'required'"
                                                    maxlength="150"
                                                    :disabled="(isAccessPlan) ? false: true">
                                                <div v-if="verrors.firstByRule('billing_city', 'required')" class="margin-bottom-5 validate-warning-msg">City is required</div>
                                            </div>
                                            <div class="col-4 col-sm-4">
                                                <b-form-select
                                                class="col-12 col-sm-12 ma-input-field"
                                                name="billing_state" v-model="billingState" v-validate="'required'"
                                                :options="state_options"
                                                :disabled="(isAccessPlan) ? false: true">
                                                </b-form-select>    
                                                <div v-if="verrors.firstByRule('billing_state', 'required')" class="margin-bottom-5 validate-warning-msg">State is required</div>
                                            </div>
                                            <div class="col-4 col-sm-4">
                                                <input 
                                                type="text" 
                                                name="zip code" 
                                                id="org_zip"
                                                ref="org_zip"
                                                v-validate="{ rules: { regex: getPostalCodeRegex(), required: true } }"
                                                v-model="billingZip"
                                                maxlength="10"
                                                class="col-12 col-sm-12 ma-input-field" 
                                                placeholder="Zip"
                                                :disabled="(isAccessPlan) ? false: true">
                                                <div v-show="verrors.has('zip code')" class="validate-warning-msg">{{ verrors.first('zip code') }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-2" v-if="isCCRequired">
                                    <div class="col-12">
                                        <label class="form-label">Credit/Debit Card Information</label>
                                        <div class="row">
                                            <div class="col-sm-12 col-md-12">
                                                <div class="row">
                                                    <div class="col-sm-12 col-md-12">
                                                        <input 
                                                            type="text" 
                                                            class="col-12 col-sm-12 ma-input-field" 
                                                            name="card_no" 
                                                            v-model="cardNumber" 
                                                            v-validate=" isCCRequired ? 'required|numeric' : '' "
                                                            placeholder="Credit Card #">
                                                        <div v-if="verrors.firstByRule('card_no', 'required')" class="margin-bottom-5 validate-warning-msg">Card Number is required</div>
                                                        <div v-if="verrors.firstByRule('card_no', 'numeric')" class="margin-bottom-5 validate-warning-msg">Card Number must contain numeric characters only</div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-12 col-md-12">
                                                        <input 
                                                            type="text" 
                                                            class="col-12 col-sm-12 ma-input-field" 
                                                            name="name_on_card" 
                                                            v-model="nameOnCard" 
                                                            v-validate=" isCCRequired ? 'required' : '' "
                                                            placeholder="Name on Card">
                                                        <div v-if="verrors.firstByRule('name_on_card', 'required')" class="margin-bottom-5 validate-warning-msg">Name on Card is required</div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-4 col-sm-4">
                                                        <select 
                                                            class="custom-select ma-input-field" 
                                                            name="exp_month" 
                                                            v-model="expMonth" 
                                                            v-validate=" isCCRequired ? 'required' : '' ">
                                                            <option value="">Month</option>
                                                            <option value="01">01</option>
                                                            <option value="02">02</option>
                                                            <option value="03">03</option>
                                                            <option value="04">04</option>
                                                            <option value="05">05</option>
                                                            <option value="06">06</option>
                                                            <option value="07">07</option>
                                                            <option value="08">08</option>
                                                            <option value="09">09</option>
                                                            <option value="10">10</option>
                                                            <option value="11">11</option>
                                                            <option value="12">12</option>
                                                        </select>
                                                        <div v-if="verrors.firstByRule('exp_month', 'required')" class="margin-bottom-5 validate-warning-msg">Month is required</div>
                                                    </div>
                                                    <div class="col-4 col-sm-4">
                                                        <b-form-select
                                                            class="custom-select ma-input-field"
                                                            name="exp_year" 
                                                            v-model="expYear" 
                                                            v-validate=" isCCRequired ? 'required' : '' "
                                                            :options="year_options">
                                                        </b-form-select>
                                                        <div v-if="verrors.firstByRule('exp_year', 'required')" class="margin-bottom-5 validate-warning-msg">Year is required</div>   
                                                    </div>
                                                    <div class="col-4 col-sm-4">
                        <input 
                            type="password" 
                            class="col-12 col-sm-12 ma-input-field" 
                            name="cvv" 
                            placeholder="CVV"
                            v-model="cvvValue" 
                            maxlength="4"
                            v-validate=" isCCRequired ? 'required' : '' "
                            role="presentation"
                            autoComplete="new-password"
                            >
                                                        <div v-if="verrors.firstByRule('cvv', 'required')" class="margin-bottom-5 validate-warning-msg">CVV is required</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center m-4">
                                    <button :disabled="disable_process_payment" type="button" class="btn btn-sm btn-blue saveBtn text-center" @click="onSubmit">
                                        Process Payment
                                    </button>
                                </div>
                            </form>

                            <div class="my-5" style="height: 10px;"></div>
                        </div>
                        <div class="modal-footer"></div>
                    </div>
                </div>
            </div>
        </transition>

        <AddLicenseSuccessModal 
            :isAddLicenseSuccessModalVisible="isAddLicenseSuccessModalVisible"
            :paymentMethod="paymentMethod"
            :invoice_filename="invoice_filename"            
            landingPage="adminconsole"
            ref="add_license_success"
            @close="close"
        />

        <AddLicenseFailedModal
            :isAddLicenseFailedModalVisible="isAddLicenseFailedModalVisible"
            landingPage="managelicense"
            @close="close"
        />

        <CreateInvoiceConfirmModal
            :isCreateInvoiceModalVisible="isCreateInvoiceModalVisible"
            landingPage="managelicense"
            @close="close"
        />
        
    </div>
  </div>

</template>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import moment from 'moment';

import AddLicenseSuccessModal from './process_payment_success_modal.vue';
import AddLicenseFailedModal from './process_payment_failed_modal.vue';
import CreateInvoiceConfirmModal from './create_invoice_confirm_modal.vue';


Vue.filter('formatExpirationDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMMM DD, YYYY')
  }
});

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalVisible'],
    data() {
        return {
            loading: false,
            subscriptions: [],
            subscriptionId: '',
            subscription_plan: '',
            billingName: '',
            billingAddress: '',
            billingAddress2: '',
            billingCity: '',
            billingState: '',
            billingCountry: '',
            billingZip: '',
            billingPhone: '',
            nameOnCard: '',
            cardNumber: '',
            expMonth: '',
            expYear: '',
            cvvValue: '',
            year_options: [],
            subscriptionTotal: 0,
            isAccessPlan: 1,
            newAccountId: '',
            invoice_filename: '',
            close_url: '',
            country_options: [],
            state_options: [],
            isAddLicenseSuccessModalVisible: false,
            isCCRequired: 1,
            paymentMethod: 'credit_card',
            isAddLicenseFailedModalVisible: false,
            isCreateInvoiceModalVisible: false,
            activeLicense: 0,
            licenseType: '',
            invoiceNo: '',
            dueDate: '',
            price: 0,
            disable_process_payment: false,
        }
    },
    components: {
     AddLicenseSuccessModal,
     AddLicenseFailedModal,
     CreateInvoiceConfirmModal,        
    },
    methods: {       
        nameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },
        billingNameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },
        billingPhoneValid() {
            var billing_phone = this.billingPhone;
            this.billingPhone = billing_phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        phoneRegex() {
            return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        getPostalCodeRegex() {
            return /^[0-9]{5}(?:-[0-9]{4})?$/;
        },
        getCountryLists() {
            axios.get('/get-country-lists', {

            })
            .then(response =>  {
                this.country_options = response.data;
            })
            .catch(function(error) {

            });
        },
        getStateLists(CountryCode) {
            axios.get('/get-state-lists/' + CountryCode, {

            })
            .then(response =>  {
                this.state_options = response.data;
            })
            .catch(function(error) {

            });
        },
        getExpiryYears() {
            this.year_options = [
                { value: '', text: 'Year' },
            ];       
            var min = new Date().getFullYear()
            var max = min + 20;
            for (var i = min; i <= max; i++) {
                var yoptions = { value: i, text: i };
                this.year_options.push(yoptions);
            }
        },
       setSubscriptionTotal(item) {
            this.subscriptionId = item.id;
            this.subscriptionTotal = item.price;
        },
        onSubmit() {
            this.$validator.validateAll().then((result) => {
                if (this.verrors.items.length === 0) {
                    this.processPayment();
                }
                
            });
        },
        processPayment() {
            this.disable_process_payment = true;
            this.loading = true;
            axios('/process-payment-orders', 
            {
                method: 'POST',
                data: {
                        "order_id": this.orderId,
                        "subscription_total": this.subscriptionTotal,
                        "account_id": this.$store.state.user_accountid,
                        "billing_name": this.billingName,
                        "billing_address": this.billingAddress,
                        "billing_address2": this.billingAddress2,
                        "billing_city": this.billingCity,
                        "billing_state": this.billingState,
                        "billing_country": this.billingCountry,
                        "billing_zip": this.billingZip,
                        "billing_phone": this.billingPhone,
                        "payment_method": this.paymentMethod,
                        "name_oncard": this.nameOnCard,
                        "card_number": this.cardNumber,
                        "exp_month": this.expMonth,
                        "exp_year": this.expYear.toString().substr(-2),
                        "cvv_value": this.cvvValue,
                },
            })
            .then((response) => {
                this.disable_process_payment = false;
                this.loading = false;
                this.verrors.clear();
                this.invoice_filename = response.data.invoice_filename;
                if (response.data.msg != 'failed') {
                    this.isAddLicenseSuccessModalVisible = true;
                } else {
                    this.isAddLicenseFailedModalVisible = true;
                }
            })
            .catch(error => {
                this.disable_process_payment = false;
                console.log(error)
            });
        },
        getOrderDetailsLists(orderId) {
            axios.get('/get-process-payment-order-details/' + orderId)
            .then((resp) => {
                this.orderId = orderId;
                this.loading = false;
                this.invoiceNo = resp.data.invoiceNo;
                this.dueDate = resp.data.dueDate;
                this.price = resp.data.price;
                this.subscriptionTotal = resp.data.price;
            })
            .catch(error => {

            });
        },
        getLicenseTermDetails() {
            axios.get('/desktop/get-license-term-details/' + this.subscriptionId)
            .then((resp) => {              
                this.licenseDetails = resp.data;                            
            })
            .catch(error => {

            });
        },
        loadInitialData(orderId) {
            this.orderId = orderId;
            this.verrors.clear();
            this.getCountryLists();
            this.getStateLists('US');
            this.getOrderDetailsLists(orderId);
            this.getExpiryYears();
        },
        getNoRecordText(count) {
            if (this.loading) {
                return '';
            } else {
                if (count == 0) {
                    return 'No Renew Subscription';
                }
            }
        },
        close() {
            this.verrors.clear();
            if (this.close_url) {
                let routeData = this.$router.resolve({name: this.close_url});
                window.open(routeData.href, '_self');
            } else {
                let routeData = this.$router.resolve({name: 'adminconsole'});              
                window.open(routeData.href, '_self');                
            }
        },
        choosePaymentMode(event) {
            if(event.target.value == 'credit_card') {
                this.isCCRequired = 1;
            }
            else {
                this.isCCRequired = 0;                
            }
        },
        onClose() {
          this.popoverShow = false
        },
    },
    created() {
    }   
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.modal-body { padding: 0rem 1.5rem 0rem 1.5rem; overflow: auto;}
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.saveBtn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: auto;
  padding: 5px 20px;
}
.totalBtn, .totalBtn.btn-blue {
  color: #707070; 
  background-color: #FFF !important;
  border: 1px solid #707070 !important;
  border-radius: 10px;
  font-weight: 900;
  width: auto;
  padding: 8px;
}
.mx-input { height: 24px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  color: #707070;
  background-color: #efefef;
  min-height: 32px;
}
.ma-input-field:focus-visible {
  outline: none;
}
.form-label { font-size: 13px; font-weight: 900; } 
.row_data_border { padding: 5px 0; margin-bottom: 5px; font-size: 14px;border-bottom: 2px solid rgba(0, 0, 0, 0.1); }
.row_data_border:nth-last-child(1) { border-bottom: 0 none; }
.total_price { color: #00acee; }
.custom-select { height: 34px; }
.license-term-content { font-size: 12px;}
.license-term-label { color: #00ACEE; font-weight: bold; font-size: 13px; padding-top: 10px;}
.help-txt {
    display: inline-block;
    height: 15px;
    width: 15px;
    line-height: 15px;
    -moz-border-radius: 8px;
    border-radius:8px;
    border: 1px solid #00ACEE;
    background-color: white;
    color: #00ACEE;
    text-align: center;
    font-size: 0.75em;
    cursor: pointer;
}
.btn-secondary:hover { background-color: #FFF !important;}
</style>
<style>
.popover-body { padding-right: 50px !important;}
.popover-header div { text-align: center;}
button.close { font-size: 30px;margin-top: -7px;}
.popover .popover-header { font-size: 14px; font-weight: bold;}
.popover { width: 340px !important; max-width: 340px !important;}
.bs-popover-right > .arrow::before {
    border-right-color: rgba(0, 172, 238, 0.90) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/manager/process_payment.vue